import { paths } from '../routes/paths';

/** Alertas do fundo de emergência para o dashboard. */
export const EF_ALERT_TYPES = {
  EXPENSES_ABOVE_TARGET: 'ef_expenses_above_target',
  BELOW_TARGET: 'ef_below_target',
  ALLOCATION_DRIFT: 'ef_allocation_drift',
  REVIEW_ALLOCATIONS: 'ef_review_allocations',
};

export function buildEmergencyFundAlerts(apiAlerts = []) {
  if (!Array.isArray(apiAlerts)) return [];
  return apiAlerts.map((alert) => ({
    id: alert.id,
    type: alert.type,
    href: alert.type === EF_ALERT_TYPES.REVIEW_ALLOCATIONS
      ? `${paths.emergencyFundWizard}?step=allocations`
      : paths.emergencyFund,
    meta: alert.meta || {},
    severity: alert.severity || 'info',
  }));
}
